import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function EmptyNotifications() {
  return (
    <div className="empty-notifications">
      <FontAwesomeIcon icon={['fal', 'bell']} />
      <p>You're all caught up!</p>
    </div>
  );
}
